const defaultUrl = 'https://marriottinternationa.tt.omtrdc.net/rest/v1/delivery';
const defaultHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export { defaultUrl, defaultHeaders };
